(()=>{
  // Helper to add swiper classes
  let addClasses = e => {
    var wrapper = e.querySelector(".testimonials-slider-list-wrapper"),
        items = e.querySelectorAll(".testimonial-slider-item");
    e.classList.add("swiper");
    e.classList.add("js-slider-testimonials");
    if(wrapper) wrapper.classList.add("swiper-wrapper");
    items.forEach(item => { item.classList.add("swiper-slide") });
  };

  // Helper to remove swiper classes
  let removeClasses = e => {
    var wrapper = e.querySelector(".testimonials-slider-list-wrapper"),
        items = e.querySelectorAll(".testimonial-slider-item");
    e.classList.remove("swiper");
    e.classList.remove("js-slider-testimonials");
    if(wrapper) wrapper.classList.remove("swiper-wrapper");
    items.forEach(item => { 
      item.removeAttribute("style");
      item.classList.remove("swiper-slide");
    });
  };

  // Initialize Swiper
  let initSwiper = section => {
    let slider = section.querySelector(".testimonials-slider-block");
    if(!slider || slider.classList.contains("swiper-initialized")) return;
    
    addClasses(slider);
    
    var r = slider.parentNode.querySelector(".swiper-button-prev"),
        n = slider.parentNode.querySelector(".swiper-button-next"),
        s = Number(slider.dataset.columns) || 4,
        t = s < 2 ? 1.2 : 2,
        i = s < 3 ? s : 3;

    new Swiper(slider, {
      slidesPerView: 1.1,
      spaceBetween: 24,
      speed: 800,
      slidesOffsetAfter: 0,
      slidesOffsetBefore: 0,
      mousewheel: { forceToAxis: !0 },
      navigation: { prevEl: r, nextEl: n },
      // Added pagination config based on multicolumn.js
      pagination: {
        el: slider.querySelector(".testimonials__pagination"),
        clickable: !1,
        type: "custom",
        renderCustom: function(e, t, s) {
          let i = "";
          for (let e = 1; e < s + 1; e++) {
            i = e == t 
              ? `${i}<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`
              : `${i}<span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`;
          }
          return i;
        }
      },
      breakpoints: {
        576: { slidesPerView: 1.1, spaceBetween: 24 },
        750: { slidesPerView: t, spaceBetween: 24 },
        990: { slidesPerView: t, spaceBetween: 24 },
        1200: { slidesPerView: i, spaceBetween: 32 },
        1360: { slidesPerView: s, spaceBetween: 32 },
        1600: { slidesPerView: s, spaceBetween: 48 },
        1904: { slidesPerView: s, spaceBetween: 48 }
      }
    });
  };

  // Destroy Swiper
  let destroySwiper = section => {
    let slider = section.querySelector(".testimonials-slider-block");
    if(slider) {
      if(slider.swiper) slider.swiper.destroy(!0, !0);
      removeClasses(slider);
    }
  };

  // Observe resizing to toggle on desktop/mobile
  let observeSection = section => {
    if(section && section.classList.contains("section-testimonials-list")) {
      let slider = section.querySelector(".testimonials-slider-block");
      if(slider) {
        new ResizeObserver(entries => {
          entries.forEach(entry => {
            let w = entry.contentRect.width, fn;
            if(slider.dataset.sliderMobile != "true" || slider.dataset.sliderDesktop != "true") {
              if(w < 750) {
                fn = (slider.dataset.sliderMobile == "true") ? initSwiper : destroySwiper;
              } else {
                fn = (slider.dataset.sliderDesktop == "true") ? initSwiper : destroySwiper;
              }
            } else {
              fn = initSwiper;
            }
            fn(entry.target);
          });
        }).observe(section);
      }
    }
  };

  observeSection(document.currentScript.parentElement);
  document.addEventListener("shopify:section:load", function(e) { observeSection(e.target) });
})();